import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const loggedIn = localStorage.getItem("loggedIn");

  return loggedIn ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
